import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DocumentMasterCreateRequestDTO, DocumentMasterDTO } from './documentmaster.interface';
import { Observable } from 'rxjs';
import { DocumentMaster_Upload } from 'src/app/GlobalVariables';

@Injectable({
  providedIn: 'root'
})
export class DocumentMasterService {

  constructor() { }
  http = inject(HttpClient);

  DocumentMaster_Upload(data: FormData): Observable<DocumentMasterDTO> {
    return this.http.post<DocumentMasterDTO>(DocumentMaster_Upload, data);
  }

}
